import styled, {css} from 'styled-components';

import {ModalActions as BaseModalActions} from '@edna/components';
import {mixins} from '@edna/components/styles';

import {ModalCenterImage as BaseModalCenterImage} from 'src/components/primitives';

export const ModalSubHeader = styled.div`
  ${mixins.f4}
`;

export const ModalCenterImage = styled(BaseModalCenterImage)`
  margin: ${({theme}) => theme.spacing.s10} auto;
`;

export const ModalActions = styled(BaseModalActions)`
  ${({theme}) => css`
    gap: ${theme.spacing.s2};
  `}
`;
